import { GetDataCalculator } from "../../modules/calculators/GetDataCalculator";
import { formState } from "../../modules/form/FormState";
import { Typology } from "../../modules/typology/Typology";
import { loadDataAVI } from "../constants/functions/loadDataAVI";
import { hideModal, showModal } from "../constants/functions/modalFunctions";
import { setContactData } from "../constants/interfaces/ContactProjectInterface";
class FormService {
    constructor(formState) {
        this.formState = formState;
        this.nameForm = '';
        this.confirmationForm = '';
    }
    sendLead(url, formData) {
        fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        }).then(response => response.json())
            .then(response => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            this.nameForm = this.formState.manageState('formName');
            const directSendSimulator = formData.contextPath.includes('simulador');
            const directSendWizard = formData.contextOrigin == 'Qué estás buscando';
            const modalName = directSendSimulator ? 'modalContacto' : 'modalSendWizard';
            let form = document.querySelector(this.nameForm);
            if (directSendSimulator || directSendWizard) {
                form = document.getElementById(modalName);
            }
            let nameCalculator = this.formState.manageState('openCalculator');
            let showConfirmationForm = true;
            if (formData.contextPath == '/typology/') {
                const typology = new Typology(this.formState);
                const showItemsAfterSubmit = ((_a = document.querySelector('#typologyForm #contact-submit')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-show-items')) || '';
                window.sessionStorage.setItem('contactFormSent', 'true');
                (_b = form.querySelector(`.form_contac--typology`)) === null || _b === void 0 ? void 0 : _b.classList.add('d-none');
                if (screen.width < 1000 && document.getElementById('modalBanner')) {
                    showModal('modalBanner');
                    (_c = document.querySelector('#modalBanner .close-banner')) === null || _c === void 0 ? void 0 : _c.addEventListener('click', function () {
                        showModal('modalRecommend');
                    });
                    showConfirmationForm = false;
                }
                if (nameCalculator) {
                    window.sessionStorage.setItem('simulatorFormSent', 'true');
                }
                if (window.sessionStorage.getItem('simulatorFormSent')) {
                    (_d = form.querySelector('#activateSimulatorBtn')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
                    (_e = form.querySelector('#activateSimulatorSubsidyBtn')) === null || _e === void 0 ? void 0 : _e.classList.add('d-none');
                }
                else {
                    if (formData.contextComponent != 'recomendador') {
                        hideModal('modalContacto');
                        (_f = document.getElementById('confirm-send-recommend')) === null || _f === void 0 ? void 0 : _f.classList.add('d-none');
                        showModal('modalRecommend');
                    }
                    const typologyType = this.formState.manageState('typologyType');
                    const typologyCreditType = this.formState.manageState('creditType');
                    const typologyProperty = this.formState.manageState('typologyProperty');
                    if (typologyProperty != 'Lote') {
                        (_g = form.querySelector('#activateSimulatorBtn')) === null || _g === void 0 ? void 0 : _g.classList.remove('d-none');
                        if (nameCalculator == 'Calculadora de Subsidio' || ((typologyType == '11660' || typologyType == '11801') && (typologyCreditType != 'financiamiento')) || typologyCreditType == 'subsidio') {
                            (_h = form.querySelector('#activateSimulatorSubsidyBtn')) === null || _h === void 0 ? void 0 : _h.classList.remove('d-none');
                        }
                    }
                    else {
                        (_j = form.querySelector('#activateSimulatorBtn')) === null || _j === void 0 ? void 0 : _j.classList.add('d-none');
                        (_k = form.querySelector('#activateSimulatorSubsidyBtn')) === null || _k === void 0 ? void 0 : _k.classList.add('d-none');
                    }
                }
                setContactData(formData);
            }
            // Revisar en tipologia que se manden solo valores propios a calculadoras
            if (nameCalculator) {
                let dataCalculator = new GetDataCalculator(this.formState);
                dataCalculator.showResultsCalculator(formData);
                showModal('calculusModal');
            }
            if (showConfirmationForm) {
                setTimeout(() => {
                    var _a, _b;
                    (_a = form.querySelector('.load-send-form')) === null || _a === void 0 ? void 0 : _a.classList.remove("d-flex");
                    (_b = form.querySelector('.js-confirmation-mess')) === null || _b === void 0 ? void 0 : _b.classList.add("d-flex");
                }, 300);
            }
            let dataAVI = new loadDataAVI(this.formState);
            let isAVI = dataAVI.isAVI();
            if (isAVI) {
                const successAlert = document.getElementById("successAlertSend");
                if (successAlert) {
                    if (response['estado'] == 'actualizado') {
                        successAlert.textContent = "Ya estas registrado en este proyecto.";
                    }
                    else {
                        successAlert.textContent = "Te has registrado correctamente.";
                    }
                    successAlert === null || successAlert === void 0 ? void 0 : successAlert.classList.add('show');
                    setTimeout(() => {
                        successAlert === null || successAlert === void 0 ? void 0 : successAlert.classList.remove('show');
                    }, 5000);
                }
                const buttonSend = document.querySelector('#formulario_card_' + formData.preferenceNode + '.target');
                if (buttonSend) {
                    buttonSend.innerHTML = 'Enviado';
                    buttonSend.classList.remove('target');
                }
            }
            if (directSendSimulator || directSendWizard) {
                const titleConfirmation = form.querySelector('#confirm-send-form-text');
                const subtitleConfirmation = form.querySelector('#confirm-send-form-2-text');
                if (response['estado'] == "actualizado") {
                    titleConfirmation.innerText = '¡Ya se registró en este proyecto!';
                    subtitleConfirmation.innerHTML = 'La constructora se estará comunicando.';
                }
                else {
                    titleConfirmation.innerText = '¡Ya estás registrado!';
                    subtitleConfirmation.innerHTML = 'Estrenar Vivienda está más cerca que nunca.';
                }
                showModal(modalName);
                setTimeout(() => {
                    hideModal(modalName);
                }, 2000);
            }
            if (this.nameForm == '#popupTypology') {
                window.sessionStorage.setItem("popupFormSent", "true");
                setTimeout(() => {
                    showModal('popupTypology');
                    if (formState.manageState('pendingLink')) {
                        window.location.href = formState.manageState('pendingLink');
                    }
                }, 2000);
            }
            this.loadIframeSchedule(form);
            this.redirect(form);
        });
    }
    loadIframeSchedule(form) {
        const schedulingUrl = formState.manageState('schedulingUrl');
        const iframeSchedule = form.querySelector('#iframe-schedule');
        if (iframeSchedule) {
            if (schedulingUrl) {
                iframeSchedule.src = schedulingUrl;
                iframeSchedule.setAttribute('width', '400');
                iframeSchedule.classList.remove('d-none');
            }
            else {
                iframeSchedule.classList.add('d-none');
                iframeSchedule.removeAttribute('width');
            }
        }
    }
    redirect(form) {
        let projectName = formState.manageState('typologyName');
        projectName = projectName ? projectName.trim() : '';
        let builderNumber = formState.manageState('builderNumber');
        builderNumber = (builderNumber) ? builderNumber.replace(' ', '') : '';
        if (!builderNumber.includes('+57')) {
            builderNumber = '+57' + builderNumber;
        }
        let projectRedirect = formState.manageState('projectRedirect');
        let builderName = formState.manageState('builderName');
        let redirectTo = "";
        if (projectRedirect == 1 || projectRedirect == true || projectRedirect == "true") {
            redirectTo = builderNumber ? `https://api.whatsapp.com/send?phone=${builderNumber}&text=${encodeURIComponent('¡Hola! Vi el proyecto *' + projectName + '* de *' + builderName + '* en el sitio web de www.estrenarvivienda.com y me gustaría saber más. ¿Aún tienen unidades disponibles?')}` : '';
        }
        let redirectSimulator = formState.manageState('redirectSimulator');
        if (redirectSimulator) {
            redirectTo = '/simulador-credito-hipotecario';
        }
        const whatsappElement = form === null || form === void 0 ? void 0 : form.querySelector(`.js-confirmation-mess .confirm-send-form__whatsapp`);
        if (whatsappElement) {
            if (redirectSimulator) {
                whatsappElement.innerHTML = 'Te estamos redirigiendo al simulador de crédito.';
            }
            else {
                whatsappElement.innerHTML = 'Te estamos redirigiendo al WhatsApp de la sala de ventas.';
            }
            if (redirectTo) {
                whatsappElement.classList.add('d-block');
                whatsappElement.classList.remove('d-none');
            }
            else {
                whatsappElement.classList.add('d-none');
                whatsappElement.classList.remove('d-block');
            }
        }
        setTimeout(() => {
            if (redirectTo) {
                window.open(redirectTo);
            }
        }, 2000);
    }
}
export { FormService };
